import { render } from "./EResourcesView.vue?vue&type=template&id=3d432b93"
import script from "./EResourcesView.vue?vue&type=script&lang=js"
export * from "./EResourcesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__